import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaBox, FaBoxOpen, FaCamera, FaCartPlus, FaCog, FaEdit, FaFileDownload, FaFileUpload, FaImage, FaList, FaPlus, FaQrcode, FaSearch, FaTag, FaTh, FaTimes, FaTrash } from 'react-icons/fa';
import { Badge, Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Table, Toast, ToastBody, ToastHeader } from 'reactstrap';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { productActions } from '../../sagas/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import config from '../../helpers/config';
import { supplierActions } from '../../sagas/supplierSlice';
const ProductList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [criteria, setSearchCriteria] = useState({ query: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const searchInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [displayMode, setDisplayMode] = useState('card'); // or 'card'
  const [newSupplierModal, setNewSupplierModal] = useState(false);
  const [newSupplier, setNewSupplier] = useState({ name: '', contact: '', address: '' });
  const [suppliersPagination, setSuppliersPagination] = useState({ currentPage: 1, pageSize: 10 });
  const { suppliers, loading: suppliersLoading, totalPages: suppliersTotalPages, totalElements: suppliersTotalElements } = useSelector(state => state.suppliers);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchSupplierQuery, setSearchSupplierQuery] = useState('');
  const [isSupplierSearching, setIsSupplierSearching] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedNewSupplier, setSelectedNewSupplier] = useState(null);
  const [supplierModal, setSupplierModal] = useState(false);
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const {
    products,
    loading,
    totalPages,
    totalElements,
    pageNumber,
    pageSize,
    error,
  } = useSelector((state) => state.products);
  const [editModal, setEditModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedEditSupplier, setSelectedEditSupplier] = useState(null);
  const role = useSelector((state) => state.auth.role);

  const [editForm, setEditForm] = useState({
    code: '',
    description: '',
    barcode: '',
    stock: 0,
    userPrice: 0,
    buyingPrice: 0,
    supplier: null
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2000000) { // 2MB limit
        Swal.fire({
          icon: 'error',
          title: t('product.imageSizeError'),
          text: t('product.imageSizeLimitMessage'),
          confirmButtonColor: '#dc3545'
        });
        return;
      }
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // Add clear image handler
  const handleClearImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };


  // Add this to your component to handle the hover effect for action buttons
  useEffect(() => {
    // Add CSS for hover effect on action buttons
    const style = document.createElement('style');
    style.innerHTML = `
    .product-card:hover .action-buttons {
      opacity: 1 !important;
    }
  `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);



  useEffect(() => {
    // Auto focus on mount
    searchInputRef.current?.focus();

    // Add keyboard shortcut
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [products]);

  useEffect(() => {
    let payload = {
      criteria,
      page: currentPage,
      size: pageSize,
    };

    if (selectedSupplier) {
      payload.criteria.supplierId = selectedSupplier.id;
    } else {
      payload.criteria.supplierId = null;
    }

    dispatch(productActions.search(payload));
  }, [currentPage, selectedSupplier]);

  const handleSupplierSelect = (supplier) => {
    if (isModalOpen) {
      setSelectedNewSupplier(supplier);
    } else if (editModal) {
      setEditForm({ ...editForm, supplier: supplier });
      setSelectedEditSupplier(supplier);
    }
    else {
      setSelectedSupplier(supplier);
    }
    setSupplierModal(false);
  };

  const handleCloseSupplierModal = () => {
    setSupplierModal(false);
    setSearchSupplierQuery('');
  };

  const handleOpenSupplierModal = () => {
    dispatch(supplierActions.search({
      query: '',
      page: 0,
      size: 10
    }));
    setSupplierModal(true);

  };

  const handleClearSupplierFilter = () => {
    setSelectedSupplier(null);
  };


  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((query) => {
      setIsSearching(true);

      dispatch(productActions.search({
        criteria: {
          query,
          supplierId: selectedSupplier ? selectedSupplier.id : null
        },
        page: 1,
        size: pageSize,
        onSuccess: () => {
          setIsSearching(false)
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 0);
        }
      }));
    }, 1000), // Wait 500ms after last keystroke
    []
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const refrechProducts = () => {
    let payload = {
      criteria: {
        query: searchTerm,
        supplierId: selectedSupplier ? selectedSupplier.id : null
      },
      page: currentPage,
      size: pageSize,
    };
    dispatch(productActions.search(payload));
  }

  const debouncedSupplierSearch = useCallback(
    debounce((query) => {
      setIsSupplierSearching(true);
      dispatch(supplierActions.search({
        query,
        page: 0,
        size: 8,
        onSuccess: () => setIsSupplierSearching(false)
      }));
    }, 1500), // Wait 500ms after last keystroke
    []
  );

  const handleSupplierPageChange = (page) => {
    setSuppliersPagination(prev => ({ ...prev, currentPage: page }));
    dispatch(supplierActions.search({
      query: searchSupplierQuery,
      page,
      size: suppliersPagination.pageSize
    }));
  };

  const handleDelete = (productId) => {
    Swal.fire({
      title: t('product.deleteConfirmTitle'),
      text: t('product.deleteConfirmText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {

          let payload = {
            id: productId,
            onSuccess: () => {
              Swal.fire(t('product.deleted'), '', 'success');
              refrechProducts();
            },
            onError: (error) => {
              Swal.fire({
                icon: 'error',
                title: t('product.deleteError'),
                text: t('product.deleteErrorMessage')
              });
            }
          }
          dispatch(productActions.deleteProduct(payload));

        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: t('common.error'),
            text: t('product.deleteError')
          });
        }
      }
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleEdit = (product) => {
    setSelectedProduct(product);
    setEditForm({
      code: product.code,
      description: product.description,
      barcode: product.barcode,
      stock: product.stock,
      userPrice: product.userPrice,
      buyingPrice: product.buyingPrice,
      supplier: product.supplier
    });
    setEditModal(true);
  };

  const handleUpdate = () => {

    const formData = new FormData();

    // Update product data
    formData.append('id', selectedProduct.id);
    formData.append('description', editForm.description);
    formData.append('barcode', editForm.barcode);
    formData.append('userPrice', parseFloat(editForm.userPrice));
    formData.append('buyingPrice', parseFloat(editForm.buyingPrice));
    formData.append('stock', parseInt(editForm.stock));
    formData.append('supplierId', editForm.supplier ? editForm.supplier.id : 0);

    // Update image if selected
    if (selectedImage) {
      formData.append('image', selectedImage);
    }

    let payload = {
      product: formData,
      onSuccess: () => {
        setEditModal(false);
        setSelectedEditSupplier(null);
        refrechProducts();
        Swal.fire(t('product.updated'), '', 'success');
      }
    };
    dispatch(productActions.updateProduct(payload));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      // Add product data
      formData.append('description', e.target.description.value);
      formData.append('barcode', e.target.barcode.value);
      formData.append('userPrice', parseFloat(e.target.price.value));
      formData.append('buyingPrice', parseFloat(e.target.buyingPrice.value));
      formData.append('stock', parseInt(e.target.stock.value));
      formData.append('supplierId', selectedNewSupplier ? selectedNewSupplier.id : 0);

      // Add image if selected
      if (selectedImage) {
        formData.append('image', selectedImage);
      }


      // Create product
      dispatch(productActions.addProduct({
        product: formData,
        onSuccess: () => {
          toggleModal();
          // Reset form
          e.target.reset();
          setSelectedImage(null);
          Swal.fire({
            icon: 'success',
            title: t('product.addSuccess'),
            showConfirmButton: false,
            timer: 1500
          });
          setSelectedNewSupplier(null);
          // Refresh list
          let payload = {
            criteria: {
              query: searchTerm,
              supplierId: selectedSupplier ? selectedSupplier.id : null
            },
            page: currentPage,
            size: pageSize,
          };
          dispatch(productActions.search(payload));
        },
        onError: (error) => {
          console.error('Create product error:', error);
        }
      }));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: t('common.error'),
        text: error.message,
        confirmButtonColor: '#dc3545'
      });
    }
  };

  const downloadTemplate = () => {
    // Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const headers = [
      ['Description', 'Code-barres', 'Stock', 'Prix de vente', 'Prix d\'achat']
    ];

    // Create worksheet with headers
    const ws = XLSX.utils.aoa_to_sheet(headers);

    // Set column widths
    const colWidths = [
      { wch: 10 },  // Code
      { wch: 30 },  // Description
      { wch: 15 },  // Barcode
      { wch: 10 },  // Stock
      { wch: 10 }   // Price
    ];
    ws['!cols'] = colWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Products Template");

    // Generate and download file
    XLSX.writeFile(wb, "products_template.xlsx");
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ];
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: t('product.invalidFileType'),
          text: t('product.excelOnly'),
        });
        return;
      }

      try {
        const formData = new FormData();
        formData.append('file', file);

        let payload = {
          formData: formData,
          onSuccess: () => {
            Swal.fire({
              icon: 'success',
              title: t('product.uploadSuccess'),
              confirmButtonText: 'OK',
              confirmButtonColor: '#198754'
            });
            refrechProducts();
          },
        }
        dispatch(productActions.uploadProducts(payload));

      } catch (error) {
        console.error('Error parsing Excel:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erreur!',
          text: "Erreur lors de l'importation des produits",
          confirmButtonText: 'OK',
          confirmButtonColor: '#dc3545'
        });
      } finally {
        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }

    }
  };

  // Update price formatting function
  const formatPrice = (amount) => {
    const formattedPrice = new Intl.NumberFormat('fr-MA', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    return `${formattedPrice} DH`;
  };

  const DisplayToggle = () => (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="btn-group">
        <Button
          color={displayMode === 'table' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('table')}
          size="sm"
        >
          <FaList className="me-1" /> {t('common.table')}
        </Button>
        <Button
          color={displayMode === 'card' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('card')}
          size="sm"
        >
          <FaTh className="me-1" /> {t('common.cards')}
        </Button>
      </div>

      <div className="d-flex align-items-center gap-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>

        <div className="d-flex align-items-center gap-2">
          <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
            <FaAngleDoubleLeft />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <FaAngleLeft />
          </Button>

          <span className="mx-2">
            {currentPage} / {totalPages}
          </span>

          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <FaAngleRight />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
            <FaAngleDoubleRight />
          </Button>
        </div>
      </div>
    </div>
  );

  const TableView = () => (
    <>
      <div className="cart-container" style={{
        height: '600px',
        overflowY: 'auto',
        fontSize: '0.9rem',
        fontWeight: 'bold'
      }}>
        <Table hover bordered className="align-middle mb-0">
          <thead className="bg-light">
            <tr>

              <th className="align-middle">
                <FaQrcode className="me-2 text-primary" size={12} />
                {t('product.barcode')}
              </th>
              <th className="align-middle text-center">
                <FaBox className="me-2 text-primary" size={12} />
                {t('product.description')}
              </th>
              <th className="align-middle text-center">
                <FaBoxOpen className="me-2 text-primary" size={12} />
                {t('product.stockQty')}
              </th>
              <th className="align-middle text-end">
                <FaTag className="me-2 text-primary" size={12} />
                {t('product.salePrice')}
              </th>
              <th className="align-middle text-end">
                <FaTag className="me-2 text-primary" size={12} />
                {t('product.buyingPrice')}
              </th>

              <th className="align-middle text-center" style={{ width: '120px' }}>
                <FaCog className="me-2 text-primary" size={12} />
                {t('common.actions')}
              </th>
            </tr>
          </thead>

          <tbody>
            {!products || products.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="text-muted">
                    {t('product.noProducts')}
                  </div>
                </td>
              </tr>
            ) : (
              products.map((product) => (
                <tr key={product.id}>
                  <td className="align-middle">{product.barcode}</td>
                  <td className="align-middle">
                    {product.description.length > 20 ? product.description.substring(0, 20) + '...' : product.description}
                  </td>                  {/* <td className="align-middle text-center">{product.barcode}</td> */}
                  <td className="align-middle text-center">{product.stock}</td>
                  <td className="align-middle text-end">{formatPrice(product.userPrice)}</td>
                  <td className="align-middle text-end">{formatPrice(product.buyingPrice)}</td>
                  <td className="align-middle text-center">
                    <Button color="warning" size="sm" className="me-1 px-2 py-1">
                      <FaEdit size={12} onClick={() => handleEdit(product)} />
                    </Button>
                    <Button color="danger" size="sm" className="px-2 py-1">
                      <FaTrash size={12} onClick={() => handleDelete(product.id)} />
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
  const CardView = () => {
    return (
      <div className="card-container" style={{ height: '600px', overflowY: 'auto' }}>
        <Row xs={2} sm={3} md={4} lg={5} xl={6} className="g-2">
          {(!products || products.length === 0) && (
            <Col xs={12} className="text-center py-3">
              <div className="text-muted">
                <FaImage size={32} className="mb-2 opacity-50" />
                <h6>{t('product.noProducts')}</h6>
              </div>
            </Col>
          )}
          {products.map(product => (
            <Col key={product.id}>
              <Card
                className="product-card h-100 border-0"
                style={{
                  borderRadius: '6px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.09)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.06)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div className="position-relative">
                  <div className="card-image-container" style={{ height: '110px', overflow: 'hidden' }}>
                    {product.imageServerUrl ? (
                      <img
                        src={`${config.baseURL}${product.imageServerUrl}`}
                        alt={product.description}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: 'center',
                          transition: 'transform 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = 'scale(1.05)';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = 'scale(1)';
                        }}
                      />
                    ) : (
                      <div
                        className="bg-light d-flex align-items-center justify-content-center"
                        style={{ height: '100%' }}
                      >
                        <FaImage size={20} className="text-secondary opacity-50" />
                      </div>
                    )}

                    {/* Stock indicator dot */}
                    <div
                      className="position-absolute top-0 end-0 m-1"
                      style={{ zIndex: 1 }}
                    >
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: '16px',
                          height: '16px',
                          backgroundColor: product.stock > 0 ? '#28a745' : '#dc3545',
                          border: '1.5px solid white'
                        }}
                        title={product.stock > 0 ? `${t('product.inStock')} (${product.stock})` : t('product.outOfStock')}
                      />
                    </div>

                    {/* Action buttons overlay - only show on hover */}
                    <div
                      className="position-absolute bottom-0 end-0 m-1 d-flex gap-1 action-buttons"
                      style={{
                        zIndex: 1,
                        opacity: 0,
                        transition: 'opacity 0.2s ease'
                      }}
                    >
                      <Button
                        color="warning"
                        size="sm"
                        className="p-1 d-flex align-items-center justify-content-center"
                        style={{ width: '20px', height: '20px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(product);
                        }}
                        title={t('product.edit')}
                      >
                        <FaEdit size={10} />
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        className="p-1 d-flex align-items-center justify-content-center"
                        style={{ width: '20px', height: '20px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(product.id);
                        }}
                        title={t('common.delete')}
                      >
                        <FaTrash size={10} />
                      </Button>
                    </div>
                  </div>
                </div>

                <CardBody className="p-2">
                  <h6
                    className="product-title text-truncate mb-1"
                    title={product.description}
                    style={{ fontSize: '0.85rem', fontWeight: '600', lineHeight: '1.2' }}
                  >
                    {product.description}
                  </h6>

                  {product.barcode && (
                    <div className="d-flex align-items-center text-muted mb-1">
                      <FaBarcode className="me-1" size={9} />
                      <small style={{ fontSize: '0.65rem' }}>{product.barcode}</small>
                    </div>
                  )}

                  <div className="d-flex justify-content-between align-items-end mt-1">
                    <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                      {formatPrice(product.buyingPrice)}
                    </small>
                    <p className="product-price mb-0 fw-bold text-primary" style={{ fontSize: '0.9rem' }}>
                      {formatPrice(product.userPrice)}
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  const handleSupplierSearchChange = (e) => {
    const value = e.target.value;
    setSearchSupplierQuery(value);
    debouncedSupplierSearch(value);
  };


  const handleNewSupplierSubmit = () => {
    dispatch(supplierActions.addSupplier({
      ...newSupplier,
      onSuccess: () => {
        setNewSupplierModal(false);
        dispatch(supplierActions.search({ page: 0, size: 10 }));
        Swal.fire({
          icon: 'success',
          title: t('supplier.addSuccess'),
          timer: 1500
        });
        setNewSupplier({ name: '', contact: '', address: '' }); // Clear the form
      }
    }));
  };


  return (
    <Container fluid>
      <Row>
        <Col md={12} className="pe-4">
          <Card className="shadow-sm h-100">
            <CardBody>

              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t('common.loading')}</span>
                  </div>
                  <div className="mt-2 text-muted">
                    {t('common.loadingData')}
                  </div>
                </div>
              ) : (<>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Search Input - Left Side */}
                  <div className="position-relative flex-grow-1 me-3">
                    <Input
                      innerRef={searchInputRef}
                      type="text"
                      placeholder={t('product.searchPlaceholder')}
                      value={searchTerm.toUpperCase()}
                      onChange={handleSearchChange}
                      className={`ps-4 ${isSearching ? 'searching' : ''}`}
                    />
                    <FaSearch
                      style={{
                        position: 'absolute',
                        left: '10px',
                        top: '12px',
                        color: '#6c757d'
                      }}
                    />
                  </div>
                  {/* Supplier Filter */}
                  <div className="me-2">
                    {selectedSupplier ? (
                      <Button color="info" size="sm" onClick={handleClearSupplierFilter}>
                        {selectedSupplier.description} <FaTimes className="ms-1" />
                      </Button>
                    ) : (
                      <Button color="secondary" size="sm" onClick={handleOpenSupplierModal}>
                        {t('stock.selectSupplier')}
                      </Button>
                    )}
                  </div>
                  {/* Buttons - Right Side */}
                  {role && role === 'ROLE_ADMIN' && <div className="d-flex mx-3">
                    <Button color="primary" size="sm"
                      className="me-2" onClick={toggleModal}>
                      <FaPlus className="me-2" />
                      {t('product.new')}
                    </Button>
                    {/* <Button
                      color="secondary"
                      size="sm"
                      className="me-2"
                      onClick={downloadTemplate}
                    >
                      <FaFileDownload className="me-2" size={12} />
                      {t('product.downloadTemplate')}
                    </Button> */}
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => fileInputRef.current.click()}
                    >
                      <FaFileUpload className="me-2" size={12} />
                      {t('product.uploadProducts')}
                    </Button> 
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileUpload}
                      accept=".xlsx,.xls"
                      style={{ display: 'none' }}
                    />
                  </div>}
                </div>
                <DisplayToggle />
                {displayMode === 'table' ? <TableView /> : <CardView />}
              </>)}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Edit Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)} size='lg'>
        <ModalHeader toggle={() => setEditModal(false)}>
          {t('product.edit')}
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>{t('product.code')}</Label>
                  <Input
                    value={editForm.code}
                    onChange={(e) => setEditForm({ ...editForm, code: e.target.value })}
                    disabled={true}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>{t('product.description')}</Label>
                  <Input
                    value={editForm.description}
                    onChange={(e) => setEditForm({ ...editForm, description: e.target.value.toUpperCase() })}
                    disabled={role !== 'ROLE_ADMIN'}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>{t('product.barcode')}</Label>
                  <Input
                    value={editForm.barcode}
                    onChange={(e) => setEditForm({ ...editForm, barcode: e.target.value })}
                    disabled={role !== 'ROLE_ADMIN'}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>{t('product.salePrice')}</Label>
                  <Input
                    type="number"
                    value={editForm.userPrice}
                    step="0.1"
                    onChange={(e) => setEditForm({ ...editForm, userPrice: e.target.value })}
                    disabled={role !== 'ROLE_ADMIN'}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>{t('product.buyingPrice')}</Label>
                  <Input
                    type="number"
                    value={editForm.buyingPrice}
                    step="0.1"
                    disabled={role !== 'ROLE_ADMIN'}
                    onChange={(e) => setEditForm({ ...editForm, buyingPrice: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="stock">{t('product.stockQty')}</Label>
                  <Input
                    id="stock"
                    name="stock"
                    type="number"
                    value={editForm.stock}
                    onChange={(e) => setEditForm({ ...editForm, stock: parseInt(e.target.value) })}
                    disabled={role !== 'ROLE_ADMIN'}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="supplier">{t('stock.supplier')}</Label>
                  <div className="d-flex align-items-center">
                    <Input
                      id="supplier"
                      name="supplier"
                      type="text"
                      value={editForm.supplier ? editForm.supplier.description : ''}
                      disabled
                    />
                    <Button
                      color="secondary"
                      onClick={() => {
                        setSelectedProduct(selectedProduct);
                        setSelectedEditSupplier(editForm.supplier);
                        setSupplierModal(true);
                      }}
                      className="ms-2"
                      disabled={role !== 'ROLE_ADMIN'}
                    >
                      <FaSearch />
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>{t('product.image')}</Label>
                  <div className="d-flex align-items-center gap-3">
                    {imagePreview ? (
                      <div className="position-relative">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                          className="border rounded"
                        />
                        <Button
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0 rounded-circle"
                          onClick={handleClearImage}
                          disabled={role !== 'ROLE_ADMIN'}
                        >
                          <FaTimes />
                        </Button>
                      </div>
                    ) : (
                      <div
                        className="border rounded d-flex align-items-center justify-content-center"
                        style={{ width: '100px', height: '100px', cursor: 'pointer' }}
                        onClick={() => document.getElementById('productImage').click()}
                      >
                        <FaCamera size={24} className="text-muted" />
                      </div>
                    )}
                    <Input
                      type="file"
                      id="productImage"
                      accept="image/*"
                      onChange={handleImageChange}
                      style={{ display: 'none' }}
                      disabled={role !== 'ROLE_ADMIN'}
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          {role && role === 'ROLE_ADMIN' && <Button color="primary" onClick={handleUpdate}>
            {t('common.save')}
          </Button>}
          <Button color="secondary" onClick={() => setEditModal(false)}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={isModalOpen} toggle={toggleModal} size='lg'>
        <ModalHeader toggle={toggleModal}>
          {t('product.createNew')}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="description">{t('product.description')}</Label>
                  <Input
                    id="description"
                    name="description"
                    type="text"
                    required
                    onChange={(e) => e.target.value = e.target.value.toUpperCase()}
                    style={{ textTransform: 'uppercase' }}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="barcode">{t('product.barcode')}</Label>
                  <Input
                    id="barcode"
                    name="barcode"
                    type="text"
                    onChange={async (e) => {
                      const barcode = e.target.value;
                      if (barcode) {
                        let payload = {
                          barcode: barcode,
                          onSuccess: (data) => {
                            Swal.fire({
                              icon: 'warning',
                              title: t('product.duplicateBarcode'),
                              text: t('product.barcodeExistsFor', { product: data.description }),
                              //showCancelButton: true,
                              confirmButtonText: t('common.continue'),
                              //cancelButtonText: t('common.cancel')
                            }).then((result) => {
                              if (result.isConfirmed) {
                                e.target.value = '';
                              }
                            });
                          }
                        };
                        dispatch(productActions.checkBarcode(payload));

                      }
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="userPrice">{t('product.salePrice')}</Label>
                  <Input
                    id="userPrice"
                    name="price"
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="buyingPrice">{t('product.buyingPrice')}</Label>
                  <Input
                    id="buyingPrice"
                    name="buyingPrice"
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="stock">{t('product.stockQty')}</Label>
                  <Input
                    id="stock"
                    name="stock"
                    type="number"
                    disabled
                    defaultValue={0}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="supplier">{t('stock.supplier')}</Label>
                  <div className="d-flex align-items-center">
                    <Input
                      id="supplier"
                      name="supplier"
                      type="text"
                      value={selectedNewSupplier ? selectedNewSupplier.description : ''}
                      disabled
                    />
                    <Button
                      color="secondary"
                      onClick={() => setSupplierModal(true)}
                      className="ms-2"
                    >
                      <FaSearch />
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>{t('product.image')}</Label>
                  <div className="d-flex align-items-center gap-3">
                    {imagePreview ? (
                      <div className="position-relative">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                          className="border rounded"
                        />
                        <Button
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0 rounded-circle"
                          onClick={handleClearImage}
                        >
                          <FaTimes />
                        </Button>
                      </div>
                    ) : (
                      <div
                        className="border rounded d-flex align-items-center justify-content-center"
                        style={{ width: '100px', height: '100px', cursor: 'pointer' }}
                        onClick={() => document.getElementById('productImage').click()}
                      >
                        <FaCamera size={24} className="text-muted" />
                      </div>
                    )}
                    <Input
                      type="file"
                      id="productImage"
                      accept="image/*"
                      onChange={handleImageChange}
                      style={{ display: 'none' }}
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <div className="text-end">
              <Button color="secondary" onClick={toggleModal} className="me-2">
                {t('common.cancel')}
              </Button>
              <Button color="primary" type="submit">
                {t('common.save')}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={supplierModal} toggle={handleCloseSupplierModal}>
        <ModalHeader toggle={handleCloseSupplierModal}>
          {t('stock.selectSupplier')}
        </ModalHeader>
        <ModalBody>

          {suppliersLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{t('common.loading')}</span>
              </div>
              <div className="mt-2 text-muted">
                {t('common.loadingData')}
              </div>
            </div>
          ) : (<>
            <div className="d-flex justify-content-between mb-3">
              <Input
                placeholder={t('stock.searchSupplier')}
                value={searchSupplierQuery}
                className={`${isSupplierSearching ? 'searching' : ''}`}
                onChange={e => handleSupplierSearchChange(e)}
              />

              <Button
                color="primary"
                className="ms-2"
                onClick={() => setNewSupplierModal(true)}
              >
                <FaPlus className="me-1" />
                {t('supplier.new')}
              </Button>

            </div>
            <div className="table-responsive">
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>{t('supplier.code')}</th>
                    <th>{t('supplier.description')}</th>
                  </tr>
                </thead>
                <tbody>
                  {!suppliers || suppliers.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        <div className="text-muted">
                          {t('product.noProducts')}
                        </div>
                      </td>
                    </tr>
                  ) : (suppliers.map((supplier) => (
                    <tr key={supplier.id} onClick={() => handleSupplierSelect(supplier)}>
                      <td>{supplier.code}</td>
                      <td>{supplier.description}</td>
                    </tr>
                  ))
                  )}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <small className="text-muted">
                {t('product.showing', {
                  start: (suppliersPagination.currentPage - 1) * suppliersPagination.pageSize + 1,
                  end: Math.min(suppliersPagination.currentPage * suppliersPagination.pageSize, suppliersTotalElements),
                  total: suppliersTotalElements,
                  currentPage: suppliersPagination.currentPage,
                  totalPages: suppliersTotalPages
                })}
              </small>
              <Pagination size="sm" className="mb-0">
                <PaginationItem disabled={suppliersPagination.currentPage === 1}>
                  <PaginationLink first onClick={() => handleSupplierPageChange(suppliersPagination.currentPage > 0 ? suppliersPagination.currentPage - 1 : 0)}>
                    <FaAngleDoubleLeft size={12} />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={suppliersPagination.currentPage === 1}>
                  <PaginationLink previous onClick={() => handleSupplierPageChange(suppliersPagination.currentPage > 0 ? suppliersPagination.currentPage - 1 : 0)}>
                    <FaAngleLeft size={12} />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={suppliersPagination.currentPage === suppliersTotalPages}>
                  <PaginationLink next onClick={() => handleSupplierPageChange(suppliersPagination.currentPage + 1)}>
                    <FaAngleRight size={12} />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={suppliersPagination.currentPage === suppliersTotalPages}>
                  <PaginationLink last onClick={() => handleSupplierPageChange(suppliersTotalPages)}>
                    <FaAngleDoubleRight size={12} />
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </div>
          </>)}
        </ModalBody>
      </Modal>
      {/* New Supplier Modal */}
      <Modal isOpen={newSupplierModal} toggle={() => setNewSupplierModal(false)}>
        <ModalHeader toggle={() => setNewSupplierModal(false)}>
          {t('supplier.new')}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>{t('supplier.description')}</Label>
            <Input
              value={newSupplier.description}
              onChange={e => setNewSupplier({ ...newSupplier, description: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  document.getElementById('supplierContact').focus();
                }
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>{t('supplier.contact')}</Label>
            <Input
              id="supplierContact"
              value={newSupplier.contact}
              onChange={e => setNewSupplier({ ...newSupplier, contact: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  document.getElementById('supplierAddress').focus();
                }
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>{t('supplier.address')}</Label>
            <Input
              id="supplierAddress"
              type="textarea"
              value={newSupplier.address}
              onChange={e => setNewSupplier({ ...newSupplier, address: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  document.getElementById('saveSupplierButton').focus();
                }
              }}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button id="saveSupplierButton" color="primary" onClick={handleNewSupplierSubmit}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleNewSupplierSubmit();
              }
            }}
          >
            {t('common.save')}
          </Button>
          <Button color="secondary" onClick={() => setNewSupplierModal(false)}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
    </Container>

  );
};

export default ProductList;
